import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { PERMISSIONS } from "../constants/permissions";
import ProtectedRoute from "../contexts/ProtectedRoute";
import RequirePermission from "../contexts/RequirePermission";
import RequireAdminGroup from "../contexts/RequireAdminGroup";
import BlogDetail from "../pages/blog/BlogDetail";
import BlogList from "../pages/blog/BlogList";
// import Signup from "../pages/auth/Signup";
// import Login from "../pages/auth/Login";
// import ForgotPassword from "../pages/auth/ForgotPassword";
// import ResetPassword from "../pages/auth/ResetPassword";
import { Box } from "@mui/material";
import Sidebar from "../layout/SideBar";
import TopBar from "../layout/TopBar";
import PendingApprovalWatcher from "../pages/bookings/view-booking2/components/PendingApprovalWatcher";
import Contacts from "../pages/contacts/ListContacts";
import AddCompany from "../pages/contacts/components/AddCompanyContact";
import AddIndividual from "../pages/contacts/components/AddIndividualContact";
import CompanyView from "../pages/contacts/components/CompanyContactView";
import Home from "../pages/stream-management/ListStreams";
import Venues from "../pages/venues/ListVenues";
//import IndividualView from "../pages/contacts/components/IndividualContactView";
import Changelog from "../layout/ChangeLog";
import Configurations from "../pages/configurations/Configurations";
import EditCompany from "../pages/contacts/components/EditCompanyContact";
import EditIndividual from "../pages/contacts/components/EditIndividualContact";
import Gear from "../pages/gear-management/ListGear";
import Marketing from "../pages/marketing/Home";
import Reports from "../pages/reports/Home";
import Sales from "../pages/sales/Home";
import Settings from "../pages/settings/Home";
import AddStream from "../pages/stream-management/AddStream";
import EditStream from "../pages/stream-management/EditStream";
import TenDayForecast from "../pages/stream-management/TenDayForecast";
import JobCard from "../pages/job-card/JobCard";
// import ViewStream from "../pages/stream-management/ViewStream";
import "../App.css";
import PackageData from "../pages/configurations/packages/PackageData";
import PackageBuilderPage from "../pages/configurations/packages/package-builder/PackageBuilderPage";
import RequirementsRegistryPage from "../pages/configurations/packages/requirements-registry/RequirementsRegistryPage";
// import { PilotReviews } from "../pages/crew-management/tabs/reviews";
import Availability from "../pages/crew-management/tabs/Availability";
// import MemorialPage from "../pages/stream-management/components/memorial-page/MemorialPage";
import AllCrew from "../pages/crew-management/AllCrew";
import Checklists from "../pages/crew-management/Checklists";
import CrewManagement from "../pages/crew-management/CrewDashboard";
import CrewRatings from "../pages/crew-management/CrewRatings";
import RateCards from "../pages/crew-management/RateCards";
import ViewChecklist from "../pages/crew-management/ViewChecklist";
import ViewCrewMember from "../pages/crew-management/ViewCrewMember";
// import Setup2FA from "../pages/auth/Setup2FA";
// import Verify2FA from "../pages/auth/Verify2FA";
import AutoLogPage from "../pages/autolog/AutologPage";
import EmployeeProfilePage from "../pages/autolog/components/EmployeeProfilePage/EmployeeProfilePage";
import B2BLanding from "../pages/b2b-landing/B2BLanding";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import TermsOfService from "../pages/legal/TermsOfService";
import DataDeletion from "../pages/legal/DataDeletion";
import ChurchBookingForm from "../pages/bookings/components/ChurchBookingForm";
import ViewBookingPage2 from "../pages/bookings/view-booking2/ViewBooking2";
import BugReportWidget from "../pages/bug-report/BugReport";
import BugAssignmentModal from "../pages/bug-report/BugAssignmentModal";
import BugReportDashboard from "../pages/bug-report/BugsDashboard";
import BulkCrewAssignment from "../pages/callsheet/BulkCreateCallsheet";
import Insights from "../pages/chema/Insights";
import CampaignInsight from "../pages/chema/campaign/CampaignInsight";
import ClientAdminDashboard from "../pages/client-portal-admin/ClientMemorialDashboard";
import ViewMemorialPage from "../pages/client-portal-admin/ViewMemorialPages";
import ComingSoonPage from "../pages/coming-soon/ComingSoonPage";
import CoverProposalTemplate from "../pages/configurations/cover-proposal-templates/CoverProposalTemplate";
import IntroductionLetterConfiguration from "../pages/configurations/introduction-letter-templates/IntroductionLetter";
import RolesPermissions from "../pages/configurations/roles/RolesPermissions";
import SessionSettings from "../pages/configurations/session-settings/SessionSettings";
import VenueWebsiteVisibility from "../pages/configurations/venue-website-visibility/VenueWebsiteVisibility";
import ChemaPricingConfig from "../pages/configurations/chema-pricing/ChemaPricingConfig";
import ApiApplicationsList from "../pages/configurations/api-applications/ApiApplicationsList";
import ApiApplicationForm from "../pages/configurations/api-applications/ApiApplicationForm";
import AddRolePage from "../pages/configurations/roles/add-role/AddRolePage";
import ViewRolePermissions from "../pages/configurations/roles/ViewRolePermissions";
import ShareMessageConfiguration from "../pages/configurations/share-messages/ShareMessageConfig";
import InternetAgreementConfiguration from "../pages/configurations/internet-agreement/InternetAgreementConfiguration";
import CompetencyQuestionTemplates from "../pages/configurations/competency-templates/CompetencyQuestionTemplates";
import TestimonialsManager from "../pages/configurations/testimonials/ListTestimonials";
import TemplateManager from "../pages/configurations/thumbnails/TemplateManager";
import VenuesWidgetAdmin from "../pages/configurations/venues-admin-config/VenuesWidgetsAdmin";
import ViewChecklistItems from "../pages/crew-management/checklists/ViewChecklistItems";
import MainDashboard from "../pages/dashboard/DashboardPage";
import EndpointRequestsPage from "../pages/endpoint-requests/EndpointRequestsPage";
import ListDesigns from "../pages/figma-designs/ListDesigns";
import LandingPage from "../pages/landing/components/LandingPage";
import AcademyDashboard from "../pages/lms/academy/AcademyDashboard";
import AcademyCourses from "../pages/lms/academy/AcademyCourses";
import AcademyCourseViewer from "../pages/lms/academy/AcademyCourseViewer";
import AcademyCourseAdmin from "../pages/lms/academy/AcademyCourseAdmin";
import AcademyCourseEditor from "../pages/lms/academy/AcademyCourseEditor";
import AppHome from "../pages/mms-landingpage/AppHome";
import ProposalBuilde from "../pages/proposal/proposal-builder/ProposalBuilder";
import { ProposalDashboards } from "../pages/proposal/proposal-dashboard/ProposalDashboard";
import ServiceQuotation from "../pages/proposal/quotations/Quotation";
import RequestedQuotesDashboard from "../pages/proposal/quotations/QuoteRequestDashboard";
import QuoteRequestView from "../pages/proposal/quotations/QuoteRequestView";
import ServiceQuoteForm from "../pages/proposal/service-quote-form/ServiceQuoteForm";
import QuoteRequestPreview from "../pages/proposal/service-quote-form/components/QuoteRequestPreview";
import SiteVisitList from "../pages/site-visit/SiteVisitList";
import ViewStream from "../pages/stream-management/ViewStream";
import PixelPilotApplicationForm from "../pages/stream-management/components/PixelPilotApplicationForm";
import JobsAdminPage from "../pages/jobs/JobsAdminPage";
import CompetencyReviewPage from "../pages/jobs/CompetencyReviewPage";
import VideosPage from "../pages/jobs/VideosPage";
import ServiceDeliveryNotePage from "../pages/stream-management/components/ServiceDeliveryNotePage";
import StreamReport from "../pages/stream-management/components/StreamReport";
import TableTentPrintPage from "../pages/stream-management/components/TableTent";
import CallSheetLayout from "../pages/stream-management/components/callsheet/CallSheetPage";
import MemorialPage from "../pages/stream-management/components/memorial-page/MemorialPage";
import MemoryBookDashboard from "../pages/stream-management/components/memorial-page/comments-compiler/MemoryBookDashboard";
import EftpayResult from "../pages/stream-management/components/memorial-page/components/chema/EftpayResult";
import ChemaForm from "../pages/stream-management/components/memorial-page/components/chema/Form";
import ZimswitchResult from "../pages/stream-management/components/memorial-page/components/chema/ZimswitchResult";
import MemoryTableComponent from "../pages/stream-management/components/memory-table/MemoryTableListing";
import MemoryTableView2 from "../pages/stream-management/components/memory-table/MemoryTableView2";
import ViewStreamV2 from "../pages/stream-management/view-stream-v2/ViewStreamV2";
import EmploymentHistoryView from "../pages/users-admin/EmploymentHistoryView";
import UserManagement from "../pages/users-admin/UserManagement";
import UserProfile from "../pages/users-admin/UserProfile";

//import AddCompanyForm from "../pages/companies/AddCompanyForm";
import ListCompanies from "../pages/companies/ListCompanies";
//import IndividualCompanyView from "../pages/companies/ViewCompany";
//import EditCompanyForm from "../pages/companies/EditCompany";
import { ComponentProvider } from "../contexts/ComponentContext";
import ForgotPassword from "../pages/auth/components/ForgotPassword";
import Login from "../pages/auth/components/LoginPage";
import ResetPassword from "../pages/auth/components/ResetPassword";
import Setup2FA from "../pages/auth/components/Setup2FA";
import Verify2FA from "../pages/auth/components/Verify2FA";
import ComponentManager from "../pages/configurations/component-lead/ComponentManager";
import Footer from "../pages/configurations/component-lead/Footer";
import DonationLanding from "../pages/donation-landing/DonationLanding";
import ReferralPage from "../pages/referral-program/RefferalPage";
// Signup route removed: MMS staff are provisioned by an admin, not self-signup.
import RequestDetails from "../pages/sponsorships/RequestDetails";
import Sponsorships from "../pages/sponsorships/Sponsorships";
// Layout component for authenticated routes
import Funeral404Page from "../layout/404";
import AccessDenied from "../layout/AccessDenied";
import BookingListVersion2 from "../pages/bookings/list-booking2/BookingListV2";
import SEOManagement from "../pages/configurations/seo-management/SEOManagement";
import SEOWebsitePages from "../pages/configurations/seo-management/SEOWebsitePages";
import SEOPageEditorRoute from "../pages/configurations/seo-management/SEOPageEditorRoute";
import FreeChurchStreamsPage from "../pages/proposal/free-church-streams/FreeChurchStreamsPage";
import ReferralDetailsPage from "../pages/referral-program/ViewReferralPage";
import SponsorshipPage from "../pages/sponsorships/service-pill-box/SponsorshipPages";
import SummitConferencePage from "../pages/stream-management/components/memorial-page/components/templates/conference/template-2/SummitConferencePage";
import StreamListV2 from "../pages/stream-management/list-stream2/StreamListV2";
import { BaseURL } from "../service/Api";
// import { ReferralProgramsPage } from "../pages/referral-program/refferal-overview/ReferralProgramPage";
import TawkChat from "../components/TawkChat";
import AddBookingV2 from "../pages/bookings/add-booking2/AddBookingV2";
import EditBookingV2 from "../pages/bookings/add-booking2/EditBookingV2";
import BookingReviewPage from "../pages/bookings/view-booking2/components/ClientReview";
import ClientReviewFlow from "../pages/bookings/view-booking2/components/ClientReviewFlow";
import ViewCompany2 from "../pages/companies/ViewCompanyDetails2";
import AddCompanyV2 from "../pages/companies/add-company2/AddCompanyV2";
import EditCompanyV2 from "../pages/companies/add-company2/EditCompany2";
import DashboardWidgetsAdmin from "../pages/configurations/dashboard-widgets/DashboardWidgetsAdmin";
import FooterLinksManager from "../pages/configurations/footer-manager/FooterLinksManager";
import { SitesListing } from "../pages/configurations/site-listings/SiteListings";
import TvDashboardTemplatesAdmin from "../pages/configurations/tv-dashboard-templates/TvDashboardTemplatesAdmin";
import UpcomingFeaturesConfig from "../pages/configurations/upcoming-features/UpcomingFeaturesConfig";
import YouTubeChannelListPage from "../pages/configurations/youtube-channels/YoutubeChannelListPage";
import YouTubeChannelViewPage from "../pages/configurations/youtube-channels/YoutubeChannelViewPage";
import IndividualContactView2 from "../pages/contacts/components/IndividualContactView2";
import ListSets from "../pages/gear-management/ListSet";
import CatalogDetailPage from "../pages/gear-management/components/CatalogDetailPage";
import GearManagementDashboard from "../pages/gear-management/components/GearManagementDashboard";
import ListCatalog from "../pages/gear-management/components/ListCatalog";
import ViewEquipmentPage from "../pages/gear-management/components/ViewEquipment";
import ViewGearSetPage from "../pages/gear-management/components/ViewGearSet";
import OperationsDashboard from "../pages/operations/OperationsDashboard";
import CrewAssignmentPage from "../pages/operations/components/CrewAssignmentPage";
import CompleteRegistration from "../pages/referral-program/components/CompleteRegistration";
import ReferralDashboard from "../pages/referral-program/referrals-dashboard/Referralsdashboard";
import PublicBookingPage from "../pages/referral-program/referrals-dashboard/components/client-booking/PublicBookingPage";
import ReferralProgramAdmin from "../pages/referral-program/refferal-overview/ReferralProgramAdmin";
import StreamFundApplicationDetail from "../pages/streamfund/StreamFundApplication";
import StreamFundDashboard from "../pages/streamfund/StreamFundDashboard";
import TVDashboard from "../pages/tv-dashboard/TVDashboard";
import PixelPilotsBoard from "../pages/pixel-pilots-board/PixelPilotsBoard";
import AddVenue2 from "../pages/venues/add-venue2/AddVenue2";
import EditVenue2 from "../pages/venues/add-venue2/EditVenue2";
import ViewVenueV2 from "../pages/venues/view-venue-v2/ViewVenue2";
//import AddIndividualContactV2 from "../pages/contacts/components/add-companyV2/AddIndividualContactV2";
//import AddCompanyForm from "../pages/companies/AddCompanyForm";
import AddEmailTemplate from "../pages/configurations/email-templates/AddEmailTemplate";
import EditEmailTemplate from "../pages/configurations/email-templates/EditEmailTemplate";
import EmailTemplates from "../pages/configurations/email-templates/EmailTemplates";
import EmailTemplateDetail from "../pages/configurations/email-templates/components/EmailTemplateDetail";
import CostAnalysis from "../pages/cost-analysis/CostAnalysis";
import StreamFinancialReportPage from "../pages/stream-management/financial-report/StreamFinancialReportPage";
import ResourcesPage from "../pages/resources/ResourcesPage";

import FinanceDashboard from "../pages/cost-analysis/FinancePendingApprovals";
import NotificationManagerApp from "../pages/configurations/notification-manager/NotificationManagerApp";

const isStaging =
  BaseURL?.includes("staging.muzukuru.com") || BaseURL?.includes("staging");

const AuthLayout: React.FC = () => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", width: "100%" }}>
      <Sidebar />
      <PendingApprovalWatcher />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          minWidth: 0,
          width: "100%",
          transition: "margin-left 0.3s ease",
        }}
      >
        <TopBar />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            overflowX: "hidden",
            overflowY: "auto",
          }}
        >
          <Outlet />
        </Box>

        <Footer />
      </Box>

      <BugReportWidget />
      <BugAssignmentModal />
    </Box>
  );
};

// const BookingSwitcher = (props: BookingsByTypeProps) => {
//   if (BaseURL === "https://staging.muzukuru.com/") {
//     return <BookingListVersion2 {...props} />;
//   }

//   return <Bookings {...props} />;
// };
// const VenueSwitcher = () => {
//   if (BaseURL === "https://staging.muzukuru.com/") {
//     return <ViewVenueV2 />;
//   }

//   return <ViewVenue />;
// };

// const VenueSwitcher2 = () => {
//   if (BaseURL === "https://staging.muzukuru.com/") {
//     return <AddVenue2 />;
//   }

//   return <AddVenue />;
// };

// const VenueSwitcher3 = () => {
//   if (BaseURL === "https://staging.muzukuru.com/") {
//     return <EditVenue2 />;
//   }

//   return <EditVenue />;
// };
const AppRoutes: React.FC = () => {
  return (
    <>
      {isStaging && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            border: "8px solid #FFBB00",
            pointerEvents: "none",
            zIndex: 20000,
            boxSizing: "border-box",
          }}
        />
      )}
      <ComponentProvider>
        <TawkChat />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 10001 }}
        />
        <Routes>
          {/* Non-authenticated routes */}
          <Route path="/" element={<LandingPage />} />
          {/* Public blog (headless Wagtail) — visible to anonymous + logged-in.
              Keep above the greedy "/:pageType/:id" routes. */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/review" element={<ComingSoonPage />} />
          <Route path="/pricing" element={<ComingSoonPage />} />
          <Route path="/business" element={<ComingSoonPage />} />
          <Route path="/contact" element={<ComingSoonPage />} />
          <Route path="/death-notices" element={<ComingSoonPage />} />
          <Route path="/post-funeral" element={<ComingSoonPage />} />
          <Route path="/socials" element={<ComingSoonPage />} />
          <Route path="/b2b-landing" element={<B2BLanding />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/access-denied" element={<AccessDenied />} />
          <Route path="*" element={<Funeral404Page />} />
          <Route path="/apply-for-talkshows" element={<SponsorshipPage />} />
          <Route path="/summit-conference" element={<SummitConferencePage />} />
          <Route path="/add-company" element={<AddCompanyV2 />} />
          <Route path="/view-company/:id" element={<ViewCompany2 />} />
          <Route path="/edit-company/:id" element={<EditCompanyV2 />} />
          <Route path="/cost-analysis" element={<CostAnalysis />} />

          <Route
            path="/view-contact/:id"
            element={<IndividualContactView2 />}
          />

          <Route
            path="/review/:reference_number"
            element={<BookingReviewPage />}
          />
          <Route
            path="/client-review/:reference_number"
            element={<ClientReviewFlow />}
          />
          <Route
            path="/referral-dashboard/:id"
            element={<ReferralDashboard />}
          />
          <Route
            path="/referral/:id/client-booking"
            element={<PublicBookingPage />}
          />
          <Route path="/referral-program" element={<ReferralPage />} />
          <Route path="/refferal-program" element={<ReferralPage />} />
          <Route
            path="/complete-registration"
            element={<CompleteRegistration />}
          />
          {/* Self-signup removed: MMS staff are provisioned by an admin. */}
          <Route path="/chema/zimswitch/result" element={<ZimswitchResult />} />
          <Route path="/chema/eftpay/result" element={<EftpayResult />} />
          <Route path="/:pageType/:id/*" element={<MemorialPage />} />
          <Route path="/:pageType/:id/:fullName" element={<MemorialPage />} />
          <Route
            path="/:pageType/:id/:fullName/chema"
            element={<ChemaForm />}
          />
          <Route path="/figma-designs" element={<ListDesigns />} />
          <Route path="/login" element={<Login />} />
          <Route path="/setup-2fa" element={<Setup2FA />} />
          <Route path="/verify-2fa" element={<Verify2FA />} />
          <Route
            path="/pixel-pilot-application-form"
            element={<PixelPilotApplicationForm />}
          />
          <Route path="/donation-landing" element={<DonationLanding />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          {/* <Route path="/reviews" element={<Reviews />} /> */}
          <Route path="/availability" element={<Availability />} />
          <Route
            path="/reset-password/:uidb64/:token"
            element={<ResetPassword />}
          />
          <Route
            path="/free-church-streams"
            element={<FreeChurchStreamsPage />}
          />
          <Route path="/funeral-quote" element={<ServiceQuoteForm />} />
          <Route path="/quote/:id" element={<QuoteRequestPreview />} />

          <Route
            path="/app-home"
            element={
              <ProtectedRoute>
                <AppHome />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tv-dashboard"
            element={
              <ProtectedRoute>
                <TVDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pixel-pilots-board"
            element={
              <ProtectedRoute>
                <PixelPilotsBoard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sales"
            element={
              <ProtectedRoute>
                <Sales />
              </ProtectedRoute>
            }
          />
          <Route
            path="/operations"
            element={
              <ProtectedRoute>
                <OperationsDashboard />
              </ProtectedRoute>
            }
          />

          {/* Authenticated routes with layout */}
          <Route element={<AuthLayout />}>
            <Route
              path="/resources"
              element={
                <ProtectedRoute>
                  <ResourcesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <JobsAdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs/videos"
              element={
                <ProtectedRoute>
                  <VideosPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs/competency-reviews"
              element={
                <ProtectedRoute>
                  <CompetencyReviewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chema"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.DONATION_VIEW}>
                    <Insights />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/chema/:campaignId"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.DONATION_VIEW}>
                    <CampaignInsight />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/memory-book-dashboard"
              element={
                <ProtectedRoute>
                  <MemoryBookDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/service-delivery-note"
              element={
                <ProtectedRoute>
                  <ServiceDeliveryNotePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <MainDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/job-card"
              element={
                <ProtectedRoute>
                  <JobCard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pending-approval"
              element={
                <ProtectedRoute>
                  <FinanceDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-management"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.USER_MANAGEMENT_VIEW}
                  >
                    <UserManagement />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-management/view/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.USER_MANAGEMENT_VIEW}
                  >
                    <UserProfile />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-management/employment-history"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.USER_MANAGEMENT_VIEW}
                  >
                    <EmploymentHistoryView />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/manage-roles"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <RolesPermissions />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/manage-roles/add"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <AddRolePage />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/manage-roles/view/:id"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <ViewRolePermissions />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/session-settings"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <SessionSettings />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/venue-website-visibility"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <VenueWebsiteVisibility />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/chema-pricing"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <ChemaPricingConfig />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/api-applications"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <ApiApplicationsList />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/api-applications/add"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <ApiApplicationForm mode="create" />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/api-applications/edit/:id"
              element={
                <ProtectedRoute>
                  <RequireAdminGroup>
                    <ApiApplicationForm mode="edit" />
                  </RequireAdminGroup>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/upcoming-features"
              element={
                <ProtectedRoute>
                  <UpcomingFeaturesConfig />
                </ProtectedRoute>
              }
            />
            {/* <Route
            path="/user-management/edit-user"
            element={
              <ProtectedRoute>
                <EditUser />
              </ProtectedRoute>
            }
          /> */}
            <Route
              path="/bookings"
              element={
                <ProtectedRoute>
                  <BookingListVersion2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sponsorships"
              element={
                <ProtectedRoute>
                  <Sponsorships />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sponsorships/view/:id"
              element={
                <ProtectedRoute>
                  <RequestDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/streamfund"
              element={
                <ProtectedRoute>
                  <StreamFundDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/streamfund/applications/:id"
              element={
                <ProtectedRoute>
                  <StreamFundApplicationDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/church"
              element={
                <ProtectedRoute>
                  {" "}
                  <BookingListVersion2
                    bookingType="CHURCH"
                    title="Church Bookings"
                    defaultServiceType="CHURCH"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/add/:serviceType"
              element={
                <ProtectedRoute>
                  <AddBookingV2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/:id/edit"
              element={
                <ProtectedRoute>
                  <EditBookingV2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/list-booking2"
              element={
                <ProtectedRoute>
                  <BookingListVersion2
                    bookingType="FUNERAL"
                    title="Funeral Bookings"
                    defaultServiceType="FUNERAL"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/funeral"
              element={
                <ProtectedRoute>
                  <BookingListVersion2
                    bookingType="FUNERAL"
                    title="Funeral Bookings"
                    defaultServiceType="FUNERAL"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/funeral-home"
              element={
                <ProtectedRoute>
                  <BookingListVersion2
                    bookingType="FUNERAL_HOME"
                    title="Funeral Home Bookings"
                    defaultServiceType="FUNERAL_HOME"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/other"
              element={
                <ProtectedRoute>
                  <BookingListVersion2
                    bookingType="OTHER"
                    title="Other Bookings"
                    defaultServiceType="OTHER"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/conference"
              element={
                <ProtectedRoute>
                  <BookingListVersion2
                    bookingType="CONFERENCE"
                    title="Conference Bookings"
                    defaultServiceType="CONFERENCE"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/event"
              element={
                <ProtectedRoute>
                  <BookingListVersion2
                    bookingType="EVENT"
                    title="Event bookings"
                    defaultServiceType="EVENT"
                  />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/:id"
              element={
                <ProtectedRoute>
                  <ViewBookingPage2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    {BaseURL === "https://staging.muzukuru.com/" ? (
                      <StreamListV2 />
                    ) : (
                      <Home />
                    )}
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/add"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    <AddStream />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    {isStaging ? <ViewStreamV2 /> : <ViewStream />}
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/stream-report"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    <StreamReport />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/cost-analysis"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    <CostAnalysis />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/financial-report"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    <StreamFinancialReportPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/callsheet"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    <CallSheetLayout />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/edit"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.STREAM_VIEW}>
                    <EditStream />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/venues"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.VENUE_VIEW}>
                    <Venues />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/venues/add"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.VENUE_VIEW}>
                    <AddVenue2 />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/venues/view/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.VENUE_VIEW}>
                    <ViewVenueV2 />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            {/* <Route
          path ="/add-member"
          element={
            <ProtectedRoute>
              <UserForm/>
              </ProtectedRoute>

          }
          /> */}
            <Route
              path="venues/view/:id/edit"
              element={
                <ProtectedRoute>
                  <EditVenue2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts"
              element={
                <ProtectedRoute>
                  <Contacts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts"
              element={
                <ProtectedRoute>
                  <Contacts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/add-company-contact"
              element={
                <ProtectedRoute>
                  <AddCompany />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/add-individual"
              element={
                <ProtectedRoute>
                  <AddIndividual />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/company/view/:id"
              element={
                <ProtectedRoute>
                  <CompanyView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/view/:id/table-tent"
              element={
                <ProtectedRoute>
                  <TableTentPrintPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/individual/view/:id"
              element={
                <ProtectedRoute>
                  <IndividualContactView2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/company/edit/:id"
              element={
                <ProtectedRoute>
                  <EditCompany />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts/individual/edit/:id"
              element={
                <ProtectedRoute>
                  <EditIndividual />
                </ProtectedRoute>
              }
            />
            <Route
              path="/companies"
              element={
                <ProtectedRoute>
                  <ListCompanies />
                </ProtectedRoute>
              }
            />
            <Route
              path="/companies/add"
              element={
                <ProtectedRoute>
                  <AddCompanyV2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/companies/:id"
              element={
                <ProtectedRoute>
                  <ViewCompany2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/companies/:id/edit"
              element={
                <ProtectedRoute>
                  <EditCompanyV2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <CrewManagement />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management/all-crew"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <AllCrew />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management/checklists"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <Checklists />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management/checklists/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <ViewChecklist />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management/crew-ratings"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <CrewRatings />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management/rates"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <RateCards />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/crew-management/view/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CREW_VIEW}>
                    <ViewCrewMember />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <GearManagementDashboard />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management/list"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <Gear />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management/view/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <ViewEquipmentPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management/sets/"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <ListSets />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management/sets/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <ViewGearSetPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management/catalog/:brand_model_id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <CatalogDetailPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/gear-management/catalog"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.EQUIPMENT_VIEW}>
                    <ListCatalog />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marketing"
              element={
                <ProtectedRoute>
                  <Marketing />
                </ProtectedRoute>
              }
            />{" "}
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Reports />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <Configurations />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/autolog"
              element={
                <ProtectedRoute>
                  <AutoLogPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/autolog/:employeeId"
              element={
                <ProtectedRoute>
                  <EmployeeProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/changelog"
              element={
                <ProtectedRoute>
                  <Changelog />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memory-table"
              element={
                <ProtectedRoute>
                  <MemoryTableComponent />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memory-table/view/:id"
              element={
                <ProtectedRoute>
                  <MemoryTableView2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/ten-day-forecast"
              element={
                <ProtectedRoute>
                  <TenDayForecast />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/thumbnail-template-manager"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <TemplateManager />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/package"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <PackageData />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/package/new"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CONFIGURATION_ADD}>
                    <PackageBuilderPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/package/edit/:id"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CONFIGURATION_ADD}>
                    <PackageBuilderPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/package/requirements-registry"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CONFIGURATION_ADD}>
                    <RequirementsRegistryPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/venues-admin"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <VenuesWidgetAdmin />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/tv-dashboard-templates"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <TvDashboardTemplatesAdmin />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/footer-links"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <FooterLinksManager />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/components-manager"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <ComponentManager />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/email-templates"
              element={
                <ProtectedRoute>
                  <EmailTemplates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/email-templates/view/:id"
              element={
                <ProtectedRoute>
                  <EmailTemplateDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/email-templates/add"
              element={
                <ProtectedRoute>
                  <AddEmailTemplate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/email-templates/edit/:id"
              element={
                <ProtectedRoute>
                  <EditEmailTemplate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/notification-manager/*"
              element={
                <ProtectedRoute>
                  <NotificationManagerApp />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bookings/:id/church-form"
              element={
                <ProtectedRoute>
                  <ChurchBookingForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="muzukuru-academy"
              element={<Navigate to="/academy" replace />}
            />
            <Route
              path="/site-visit"
              element={
                <ProtectedRoute>
                  {" "}
                  <SiteVisitList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/proposals"
              element={
                <ProtectedRoute>
                  <ProposalDashboards />
                </ProtectedRoute>
              }
            />
            <Route
              path="/proposals/proposals-builder"
              element={
                <ProtectedRoute>
                  <ProposalBuilde />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bulk-crew-assignment"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CALLSHEET_VIEW}>
                    <BulkCrewAssignment />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/memorial-pages"
              element={
                <ProtectedRoute>
                  {" "}
                  <BulkCrewAssignment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memorial-pages-dashboard"
              element={
                <ProtectedRoute>
                  {" "}
                  <ClientAdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/memorial-pages-dashboard/:id"
              element={
                <ProtectedRoute>
                  {" "}
                  <ViewMemorialPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/proposal-cover-page"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    {" "}
                    <CoverProposalTemplate />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/dashboard-widgets"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    {" "}
                    <DashboardWidgetsAdmin />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/share-messages"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    {" "}
                    <ShareMessageConfiguration />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/internet-agreement"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CONFIGURATION_VIEW}>
                    <InternetAgreementConfiguration />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/competency-question-templates"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.CONFIGURATION_VIEW}>
                    <CompetencyQuestionTemplates />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stream-management/ten-day-forecast"
              element={
                <ProtectedRoute>
                  {" "}
                  <TenDayForecast />
                </ProtectedRoute>
              }
            />
            <Route path="/academy" element={<ProtectedRoute><AcademyDashboard /></ProtectedRoute>} />
            <Route path="/academy/courses" element={<ProtectedRoute><AcademyCourses /></ProtectedRoute>} />
            <Route path="/academy/courses/:id" element={<ProtectedRoute><AcademyCourseViewer /></ProtectedRoute>} />
            <Route path="/academy/admin/courses" element={<ProtectedRoute><RequireAdminGroup><AcademyCourseAdmin /></RequireAdminGroup></ProtectedRoute>} />
            <Route path="/academy/admin/courses/create" element={<ProtectedRoute><RequireAdminGroup><AcademyCourseEditor /></RequireAdminGroup></ProtectedRoute>} />
            <Route path="/academy/admin/courses/:id/edit" element={<ProtectedRoute><RequireAdminGroup><AcademyCourseEditor /></RequireAdminGroup></ProtectedRoute>} />
            <Route path="/courses/overview" element={<Navigate to="/academy" replace />} />
            <Route path="/courses" element={<Navigate to="/academy/courses" replace />} />
            <Route path="/courses/:id" element={<Navigate to="/academy/courses" replace />} />
            <Route path="/courses/create-course" element={<Navigate to="/academy/admin/courses/create" replace />} />
            <Route
              path="/proposal/service-quotation"
              element={
                <ProtectedRoute>
                  {" "}
                  <ServiceQuotation />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request-for-quote"
              element={
                <ProtectedRoute>
                  {" "}
                  <RequestedQuotesDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/request-for-quote/:id"
              element={
                <ProtectedRoute>
                  {" "}
                  <QuoteRequestView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checklists/:checklistId/sections/:sectionId"
              element={
                <ProtectedRoute>
                  {" "}
                  <ViewChecklistItems />
                </ProtectedRoute>
              }
            />
            <Route
              path="/endpoint-requests"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.ENDPOINT_REQUEST_ADMIN}
                  >
                    <EndpointRequestsPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/assign-crew"
              element={
                <ProtectedRoute>
                  <CrewAssignmentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/booking-version-two/:id"
              element={
                <ProtectedRoute>
                  <ViewBookingPage2 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/endpoint-requests/frontend"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={
                      PERMISSIONS.ENDPOINT_REQUEST_FRONTEND_ADD_COMPONENT
                    }
                  >
                    <EndpointRequestsPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/endpoint-requests/backend"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.ENDPOINT_REQUEST_BACKEND}
                  >
                    <EndpointRequestsPage />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/proposal-introduction-letter"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <IntroductionLetterConfiguration />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/testimonials"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <TestimonialsManager />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/seo-management"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <SEOManagement />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/seo-management/:siteId"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <SEOWebsitePages />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/configurations/seo-management/:siteId/:pageName"
              element={
                <ProtectedRoute>
                  <RequirePermission
                    permission={PERMISSIONS.CONFIGURATION_VIEW}
                  >
                    <SEOPageEditorRoute />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/bug-reports"
              element={
                <ProtectedRoute>
                  <RequirePermission permission={PERMISSIONS.BUG_VIEW}>
                    <BugReportDashboard />
                  </RequirePermission>
                </ProtectedRoute>
              }
            />
            <Route
              path="/referrals"
              element={
                <ProtectedRoute>
                  <ReferralProgramAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/referrals/view/:id"
              element={
                <ProtectedRoute>
                  <ReferralDetailsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/youtube-channels"
              element={
                <ProtectedRoute>
                  <YouTubeChannelListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/youtube-channels/:id"
              element={
                <ProtectedRoute>
                  <YouTubeChannelViewPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sites"
              element={
                <ProtectedRoute>
                  <SitesListing />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </ComponentProvider>
    </>
  );
};

export default AppRoutes;
